import { type ReactNode } from "react";
import { CircularProgress, Stack, Typography } from "@mui/material";

import { usePlacesOfSafety } from "../../components/FormBuilder/PlaceOfSafetyPicker/PlaceOfSafetyContext.js";
import { Error } from "../Error/Error.js";

export type PlacesOfSafetyPageProps = Record<string, never>;

export const PlacesOfSafetyPage = (
  _props: PlacesOfSafetyPageProps,
): ReactNode => {
  const {
    placesOfSafety: placesList,
    isLoading,
    isError,
  } = usePlacesOfSafety({});

  if (isError) {
    return <Error />;
  }

  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <Stack sx={{ display: "flex", textAlign: "center" }}>
      <Typography variant="h3" component="div">
        These are the Places of Safety
      </Typography>
      {placesList.length > 0 ? (
        <ul>
          {placesList.map((placeOfSafety) => (
            <li key={placeOfSafety.id}>
              <Typography variant="h3" component="div">
                {placeOfSafety.name}
              </Typography>
            </li>
          ))}
        </ul>
      ) : (
        <Typography>No places of safety found.</Typography>
      )}
    </Stack>
  );
};
